/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnumItem2
 */
export interface EnumItem2 {
    /**
     * 编码
     * @type {number}
     * @memberof EnumItem2
     */
    code?: number;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof EnumItem2
     */
    name?: string;
}

/**
 * Check if a given object implements the EnumItem2 interface.
 */
export function instanceOfEnumItem2(value: object): value is EnumItem2 {
    return true;
}

export function EnumItem2FromJSON(json: any): EnumItem2 {
    return EnumItem2FromJSONTyped(json, false);
}

export function EnumItem2FromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumItem2 {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function EnumItem2ToJSON(json: any): EnumItem2 {
    return EnumItem2ToJSONTyped(json, false);
}

export function EnumItem2ToJSONTyped(value?: EnumItem2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

